import { CheckCircle2 } from 'lucide-react';
import type { RemoteMetaCampaign } from '../campaignsApi';
const objectives: Record<string, string> = {
  OUTCOME_TRAFFIC: 'Tráfego', OUTCOME_LEADS: 'Leads', OUTCOME_SALES: 'Vendas',
  OUTCOME_ENGAGEMENT: 'Engajamento', OUTCOME_AWARENESS: 'Reconhecimento',
  LEAD_GENERATION: 'Geração de Leads', CONVERSIONS: 'Conversões', MESSAGES: 'Mensagens',
};
export function MetaImportCampaignCard({ campaign, selected, disabled, onToggle }: {
  campaign: RemoteMetaCampaign; selected: boolean; disabled: boolean; onToggle: () => void;
}) {
  const status = campaign.status === 'ACTIVE' ? 'active' : campaign.status === 'PAUSED' ? 'paused' : 'other';
  return <label className={`meta-import-campaign${selected ? ' is-selected' : ''}`}>
    <input type="checkbox" checked={selected} disabled={disabled} onChange={onToggle} aria-label={`Selecionar ${campaign.name}`} />
    <div className="meta-import-campaign-content">
      <div className="meta-import-campaign-title"><strong>{campaign.name}</strong>
        <span className={`meta-import-badge status-${status}`}>{campaign.status}</span>
        <span className="meta-import-badge">{objectives[campaign.objective] || campaign.objective || 'Geral'}</span>
        {campaign.isImported && <span className="meta-import-badge status-active"><CheckCircle2 size={12} />
          Já importada {campaign.localStatus && `(${campaign.localStatus})`}</span>}
      </div>
      <div className="meta-import-campaign-details"><span>Meta ID: <code>{campaign.id}</code></span>
        {campaign.updatedTime && <span>Atualizado: {new Date(campaign.updatedTime).toLocaleDateString('pt-BR')}</span>}
      </div>
    </div>
  </label>;
}
